export const TransactionConnectionType = {
  EmployerCheck: "employer_check",
  ContractorPaymentGroup: "contractor_payment_group",
  EmployeeCheck: "employee_check",
  ContractorPayment: "contractor_payment",
  DirectPay: "direct_pay",
  TopUp: "top_up",
  Payout: "payout",
  Invoice: "invoice",
} as const;
export type TransactionConnectionType =
  (typeof TransactionConnectionType)[keyof typeof TransactionConnectionType];
